<template>
    <div>
        <div v-if="user.has_access" class="video-player">
            <video controls>
                <source :src="`${constants.assetsUri}/${message.message}`" type="video/mp4" />
                <source :src="`${constants.assetsUri}/${message.message}`" type="video/webm" />
                <source :src="`${constants.assetsUri}/${message.message}`" type="video/ogg" />
                {{ $t('chat.videoNotSupported') }}
            </video>
        </div>
        <div v-else class="video-player">
            <video id="video" @click="playVideo($event)">
                <source :src="`${constants.assetsUri}/${message.message}`" type="video/mp4" />
                <source :src="`${constants.assetsUri}/${message.message}`" type="video/webm" />
                <source :src="`${constants.assetsUri}/${message.message}`" type="video/ogg" />
                {{ $t('chat.videoNotSupported') }}
            </video>
            <p @click="goToPlans()" class="video-subscribe-cta">
                {{ $t('chat.upgradeToWatch') }}
            </p>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { constants } from '../constants'
import { setTimeout } from 'timers'

export default {
    name: 'VideoPlayer',
    props: ['message'],
    computed: {
        ...mapGetters(['user'])
    },
    data() {
        return {
            constants,
            video: undefined
        }
    },
    methods: {
        goToPlans() {
            this.$router.push('/plans')
        },
        playVideo(event) {
            this.video = event.currentTarget
            this.video.currentTime = 0
            this.video.play()
            const self = this
            setTimeout(function() {
                self.stopVideo(self.video)
                self.$emit('openPlansPopup')
            }, 3000)
        },
        stopVideo(video) {
            video.pause()
            video.currentTime = 0
        }
    }
}
</script>

<style lang="scss" scoped>
.video-subscribe-cta {
    color: blue;
    font-size: 12px;
    max-width: 75%;
    display: inline-block;
    margin: 8px;
}
</style>
